import { getIdToken } from "src/domains/shared/utils/amplifyCompat";
import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";

export interface DeleteDrawingBundleResponse {
  /** 철거된 묶음 이름(NFD). */
  name: string;
  /** 함께 완전 삭제된 도면 식별자들 — 카탈로그의 `name` 과 같은 값. */
  drawing_names: string[];
}

/**
 * 묶음 완전 삭제 — 그 zip 이 만든 도면 전부(아직 안 지어진 것까지)와 묶음 자체를 한 요청으로.
 * `deleteDwg` 와 같은 raw fetch + Bearer 패턴이고, `name` 은 카탈로그 `bundles[].name` 그대로다.
 */
export async function deleteDrawingBundle(
  projectId: number,
  name: string
): Promise<DeleteDrawingBundleResponse> {
  const token = await getIdToken();

  const res = await fetch(
    `${backendBaseUrl()}/projects/${projectId}/drawing-meshes/bundles` +
      `?name=${encodeURIComponent(name)}`,
    {
      method: "DELETE",
      headers: { Authorization: token },
    }
  );

  if (!res.ok) {
    throw Object.assign(new Error(`묶음 삭제 실패 (${res.status})`), {
      status: res.status,
    });
  }

  const body = await res.json();
  // 응답 봉투 { status, data } 언랩
  return body.data ?? body;
}
